import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";

import React, {useEffect} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { jwtDecode } from "jwt-decode";

const pages = ['Create an RGA', 'View RGAs'];

function HeaderBar() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  useEffect(() => {
    axios.defaults.headers["Authorization"] = "Bearer " + user.token;
  });

  const handleCloseNavMenu = (event, pageName) => {
      // switch case logic here for navigating pages
      // add additional logic for 'View RGAs' where if the user's security level is not 1, redirect to view all RGAs
      // console.log(pageName)
      const decoded = jwtDecode(user.token);
      const userInfo = decoded.id;
      const rid = userInfo[1];
      if (pageName === 'Create an RGA') {
          navigate('/dashboard');
      }
      else if (pageName === 'View RGAs' && rid === 'User') {
          navigate('/view_user_rgas');
      }
      else if (pageName === 'View RGAs' && rid === 'RCPSales') {
          navigate('/view_all_rgas');
      }
      else if (pageName === 'View RGAs' && rid === 'RCPAdmin') {
          navigate('/admin_view_all_rgas');
      }
  };

  return (
      <AppBar position="static">
          <Container maxWidth="l">
              <Toolbar disableGutters={true}>
                  <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
                    {pages.map((page) => (
                      <Button
                        key={page}
                        onClick={(event) => handleCloseNavMenu(event, page)}
                        sx={{ my: 2, color: 'white', display: 'block' }}
                      >
                        {page}
                      </Button>
                    ))}
                  </Box>
                  <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                  </Box>
                  <Box sx={{ flexGrow: 0 }}>
                      <Button onClick={logout} sx={{ my: 2, color: 'white', display: 'block' }}>Logout</Button>
                  </Box>
              </Toolbar>
          </Container>
      </AppBar>
  );
}

export default HeaderBar;